export const baseClasses =
  "flex items-center justify-center rounded-lg px-6 py-2 font-semibold shadow text-nowrap";

export const hoverShadow = "hover:shadow-lg";

export type ButtonType =
  | "primary"
  | "secondary"
  | "tertiary"
  | "danger"
  | "danger-confirm";

export type LinkType = "primary" | "secondary" | "tertiary";

export const colorClasses = {
  peach: {
    primary: "bg-peach-500 text-white dark:bg-peach-500 dark:text-cream-100",
    secondary:
      "bg-peach-100 text-peach-800 dark:bg-peach-800 dark:text-peach-100",
    tertiary: "bg-transparent text-cream-700 dark:text-cream-300",
    danger: "bg-transparent text-cream-700 dark:text-cream-300",
    "danger-confirm": "bg-danger text-white",
  },
};

export const hoverColorClasses = {
  peach: {
    primary: "hover:bg-peach-600 dark:hover:bg-peach-600",
    secondary: "hover:bg-peach-200 dark:hover:bg-peach-700",
    tertiary: "",
    danger: "hover:text-danger dark:hover:text-danger",
    "danger-confirm": "hover:bg-danger/90",
  },
};
